import axios from 'axios';
import humps from 'humps';

import {
  isTokenPresent,
  getToken,
  removeToken
} from '../auth/utils/token';
import { clearSentryUser } from '../../configuration/sentryUser';

export const client = axios.create({
  headers: {
    'Content-Type': 'application/json',
    common: {
      ...(isTokenPresent() ? { Authorization: `JWT ${getToken()}` } : {}),
    },
  },
  withCredentials: false, // Set to false since we're using JWT tokens in headers, not cookies
  transformRequest: [(data) => JSON.stringify(humps.decamelizeKeys(data))],
  transformResponse: [(data) => humps.camelizeKeys(JSON.parse(data))],
});

// Add response interceptor to handle auth errors globally
client.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const isAuthEndpoint = error.config?.url?.includes('/api/me') ||
                          error.config?.url?.includes('/api/sessions');

    // Handle auth errors - clear auth and redirect to login
    // 500 on /me endpoint usually means no valid token
    if (status === 401 || status === 403 || (status === 500 && isAuthEndpoint)) {
      console.warn(`Authentication error (${status}) - clearing session and redirecting to login`);
      removeToken();
      deauthenticateClient();
      clearSentryUser();

      // Only redirect if not already on login page to avoid infinite loops
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const authenticateClient = (authenticationToken) => {
  if (authenticationToken) {
    client.defaults.headers.common[
      'Authorization'
    ] = `JWT ${authenticationToken}`;
  }
};

export const deauthenticateClient = () => {
  delete client.defaults.headers.common['Authorization'];
};
